import ClickableElement from './ClickableElement';

export default ClickableElement;
